module.exports = __webpack_public_path__ + "static/media/buy_req_rent_12.f2841063.png";